<section>
  <table class="table-responsive table table-striped table-borderless" style="padding: 20px;">
    <thead>
      <tr>
        <th scope="col">العملة</th>  
        <!-- <th scope="col">بيع</th> -->
        <th scope="col">سعر العمله</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let currency of paginatedData"style="padding: 20px;">
        <td style="width: 100px;">
          <img class="img-fluid" [src]="'assets/images/money.png'"  width="30" height="20">
          {{currency?.symbol }}
        </td>
        <!-- <td style="width: 100px;">1</td> -->
        <td style="width: 100px;">{{currency?.value }}</td>
        <!-- <td style="width: 100px;"> <img src="assets/images/trend-up.png" class="img-fluid"  width="30" height="20"></td> -->
       </tr>
    </tbody>
  </table>

  <nav class="mt-3">
    <ul class="pagination justify-content-center gap-2">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <button class="page-link" (click)="prevPage()">Previous</button>
      </li>
      <li class="page-item" *ngFor="let page of pages" [class.active]="currentPage === page">
        <button class="page-link" (click)="setPage(page)">{{ page }}</button>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <button class="page-link" (click)="nextPage()">Next</button>
      </li>
    </ul>
  </nav>
</section>

 